import React, {
  useEffect,
  useState,
} from 'react';

import {
  Button,
  Avatar,
  Rate,
  Spin,
  message,
  Typography,
} from 'antd';

import {
  FormOutlined,
} from '@ant-design/icons';

import {
  useLocation,
} from 'react-router-dom';

import TrainingsReview from './TrainingsReview';

import { TrainingsApi } from '../../Api/TrainingsApi';

const { Title } = Typography;

const TrainingsFeedback = () => {
  const location = useLocation();

  // ================= GET TRAINING ID =================

  const overviewData =
    location?.state?.overviewData || {};

  const trainingId =
    overviewData?.training_details
      ?.id;

  // ================= STATES =================

  const [feedbackData, setFeedbackData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [showReview, setShowReview] =
    useState(false);

  // ================= FETCH =================

  useEffect(() => {
    if (trainingId) {
      fetchFeedback();
    }
  }, [trainingId]);

  // ================= API =================

  const fetchFeedback = async () => {
    try {
      setLoading(true);

      const payload = {
        training_id: trainingId,
      };

      // ================= TRAINER FEEDBACK =================

      const response =
        await TrainingsApi.getTrainerFeedback(
          payload
        );

      if (response.data.success) {
        setFeedbackData(
          response.data.result || []
        );
      } else {
        message.error(
          response.data.message ||
            'Failed to fetch feedback'
        );
      }
    } catch (error) {
      console.log(error);

      message.error(
        'Error fetching feedback'
      );
    } finally {
      setLoading(false);
    }
  };

  // ================= REVIEW PAGE =================

  if (showReview) {
    return (
      <TrainingsReview
        trainingId={trainingId}
        traineeId={5}
        onBack={() => {
          setShowReview(false);

          fetchFeedback();
        }}
      />
    );
  }



  return (
    <div
   
    >
      {/* ================= HEADER ================= */}

      <div
        style={{
          display: 'flex',
          justifyContent:
            'space-between',
          alignItems: 'center',
          marginBottom: 24,
        }}
      >
        <Title
          level={4}
          style={{
            margin: 0,
            color: '#1f2a44',
          }}
        >
          Trainee ratings
        </Title>

      
      </div>

      {/* ================= EMPTY ================= */}

      {feedbackData.length === 0 && (
        <div
          style={{
            background: '#fff',
            borderRadius: 12,
            padding: 40,
            textAlign: 'center',
            color: '#8c8c8c',
          }}
        >
          No feedback available
        </div>
      )}

      {/* ================= LIST ================= */}

      {feedbackData.map((item) => {
        // ================= RATING =================

        const ratingValue =
          item.rating || 0;

        // ================= COMMENTS =================

        const comments =
          item.comments ||
          'No comments';

        // ================= AVATAR LETTER =================

        const avatarText =
          item?.trainee_name
            ?.split(' ')
            ?.map(
              (word) => word[0]
            )
            ?.join('')
            ?.slice(0, 2)
            ?.toUpperCase();

        return (
          <div
            key={item.trainee_id}
            style={{
              background: '#fff',
              border:
                '1px solid #e5e7eb',
              borderRadius: 12,
              padding: 20,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems:
                  'flex-start',
                gap: 16,
              }}
            >
              {/* AVATAR */}

              <Avatar
                size={48}
                style={{
                  background:
                    '#1677ff',
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                {avatarText}
              </Avatar>

              {/* CONTENT */}

              <div
                style={{
                  flex: 1,
                }}
              >
                {/* NAME + RATING */}

                <div
                  style={{
                    display: 'flex',
                    alignItems:
                      'flex-start',
                    justifyContent:
                      'space-between',
                    marginBottom: 8,
                  }}
                >
                  <div>
                    <h5
                      style={{
                        margin: 0,
                        fontSize: 18,
                        fontWeight: 600,
                        color:
                          '#1f2937',
                      }}
                    >
                      {
                        item.trainee_name
                      }
                    </h5>

                    <span
                      style={{
                        fontSize: 14,
                        color:
                          '#6b7280',
                      }}
                    >
                      {
                        item.department_name
                      }
                    </span>
                  </div>

                  {/* RATING */}

                  <Rate
                    disabled
                    value={
                      ratingValue
                    }
                  />
                </div>

                {/* COMMENTS */}

                <div
                  style={{
                    marginTop: 18,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      marginBottom: 8,
                      color:
                        '#374151',
                    }}
                  >
                    Comments
                  </div>

                  <p
                    style={{
                      margin: 0,
                      color:
                        '#6b7280',
                      lineHeight: 1.8,
                      fontSize: 15,
                    }}
                  >
                    {comments}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TrainingsFeedback;